import { cn } from '@/utils/utils';
import { Command, CommandEmpty, CommandInput, CommandItem, CommandList } from '@shelflix/ui-web/components/ui/command';
import { Popover, PopoverContent, PopoverTrigger } from '@shelflix/ui-web/components/ui/popover';
import { Check, ChevronDown } from 'lucide-react';
import { useState } from 'react';

const CLEAR = 'clear';

const normalize = (text: string) => text.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();

export function SearchableSelect({
  value,
  items,
  onValueChange,
  disabled,
  portalled,
}: {
  value: string;
  items: { text: string; value: unknown }[];
  onValueChange: (value: string) => void;
  disabled?: boolean;
  portalled: boolean;
}) {
  const [open, setOpen] = useState(false);
  const selectedText = items.find((item) => JSON.stringify(item.value) === value)?.text;

  const select = (next: string) => {
    onValueChange(next);
    setOpen(false);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          role="combobox"
          aria-expanded={open}
          disabled={disabled}
          className="flex h-11 w-full items-center justify-between rounded-md border border-[#0E0E0E] bg-[#191919] px-3 text-sm text-[#B2A598] disabled:cursor-not-allowed disabled:opacity-50"
        >
          <span className="truncate">{selectedText ?? 'Todos'}</span>
          <ChevronDown className="size-4 shrink-0" />
        </button>
      </PopoverTrigger>
      <PopoverContent
        portalled={portalled}
        align="start"
        className="w-(--radix-popover-trigger-width) border-[#0E0E0E] bg-[#191919] p-0 text-sm text-[#B2A598]"
      >
        <Command
          className="bg-[#191919] text-[#B2A598]"
          filter={(_value, search, keywords) =>
            normalize(keywords?.join(' ') ?? '').includes(normalize(search)) ? 1 : 0
          }
        >
          <CommandInput placeholder="Buscar..." />
          <CommandList>
            <CommandEmpty>Nenhum item encontrado</CommandEmpty>
            <CommandItem value={CLEAR} keywords={['Todos']} onSelect={() => select(CLEAR)}>
              <Check className={cn('size-4', selectedText === undefined ? 'opacity-100' : 'opacity-0')} />
              Todos
            </CommandItem>
            {items.map((item) => {
              const key = JSON.stringify(item.value);
              return (
                <CommandItem key={key} value={key} keywords={[item.text]} onSelect={() => select(key)}>
                  <Check className={cn('size-4', key === value ? 'opacity-100' : 'opacity-0')} />
                  {item.text}
                </CommandItem>
              );
            })}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
